export const GET_USER_ROLE_RELATIONS = "GET_USER_ROLE_RELATIONS"
export const GET_USER_ROLE_RELATIONS_SUCCESS = "GET_USER_ROLE_RELATIONS_SUCCESS"
export const GET_USER_ROLE_RELATIONS_FAIL = "GET_USER_ROLE_RELATIONS_FAIL"


export const ADD_USER_ROLE_RELATION = "ADD_USER_ROLE_RELATION"
export const ADD_USER_ROLE_RELATION_SUCCESS = "ADD_USER_ROLE_RELATION_SUCCESS"
export const ADD_USER_ROLE_RELATION_FAIL = "ADD_USER_ROLE_RELATION_FAIL"

export const UPDATE_USER_ROLE_RELATION = "UPDATE_USER_ROLE_RELATION"
export const UPDATE_USER_ROLE_RELATION_SUCCESS = "UPDATE_USER_ROLE_RELATION_SUCCESS"
export const UPDATE_USER_ROLE_RELATION_FAIL = "UPDATE_USER_ROLE_RELATION_FAIL"

export const DELETE_USER_ROLE_RELATION = "DELETE_USER_ROLE_RELATION"
export const DELETE_USER_ROLE_RELATION_SUCCESS = "DELETE_USER_ROLE_RELATION_SUCCESS"
export const DELETE_USER_ROLE_RELATION_FAIL = "DELETE_USER_ROLE_RELATION_FAIL"

export const API_ERROR = "API_ERROR"
